// Disabling sort-key for fields that follow the expected order of columns in the generated report
/* eslint-disable sort-keys */
export const reportsDownload = {
  brandVerticalOmi: {
    filename: "OMI_Brand_Verticals",
    fields: {
      brand_name: "Brand Name",
      vertical: "Vertical",
      brand_status: "Status"
    }
  },
  sellerOrders: {
    filename: "Seller_Store_Order_",
    fields: {
      mall_name: "Mall",
      brand_name: "Brand",
      vertical: "Vertical",
      order_status: "Order Status",
      store_order_status: "Store Order Status",
      order_date: "Order Created Date",
      shipping_schedule: "Delivery Schedule",
      completed_at: "Order Completion Date",
      store_completed_at: "Store Order Completion Date",
      order_code: "Order Code",
      store_order_code: "Store Order Code",
      shipping_method_name: "Delivery Type",
      payment_method_type: "Payment Method",
      voucher_code: "Voucher Code",
      retail_price: "Total Gross Amount",
      sales_discount_total: "Total Discount",
      selling_price: "Total Sales Amount",
      delivery_fee: "Delivery Fee",
      voucher_discount_total: "Total Voucher",
      price_paid: "Price Paid",
      order_cancel_reason: "Order Cancelation Reason",
      store_order_cancel_reason: "Store Order Cancelation Reason"
    }
  },
  storeOrdersBi: {
    filename: "OMI_Store_Orders",
    fields: {
      mall_name: "Mall",
      brand_name: "Brand",
      vertical: "Vertical",
      order_status: "Order Status",
      store_order_status: "Store Order Status",
      order_date: "Order Created Date",
      shipping_schedule: "Delivery Schedule",
      completed_at: "Order Completion Date",
      store_completed_at: "Store Order Completion Date",
      order_code: "Order Code",
      store_order_code: "Store Order Code",
      shipping_method_name: "Delivery Type",
      payment_method_type: "Payment Method",
      voucher_code: "Voucher Code",
      retail_price: "Total Gross Amount",
      sales_discount_tenant: "Tenant Discount",
      sales_discount_sm: "SMO Discount",
      sales_discount_total: "Total Discount",
      selling_price: "Total Sales Amount",
      delivery_fee: "Delivery Fee",
      voucher_discount_total: "Total Voucher",
      price_paid: "Price Paid",
      user_id: "Customer ID",
      first_name: "Customer First Name",
      last_name: "Customer Last Name",
      contact_no: "Contact Number",
      email: "Email",
      street_address_1: "Address",
      latitude: "Latitude",
      longitude: "Longitude",
      delivery_distance_in_km: "Delivery Distance in KM",
      shipping_address_id: "Shipping ID",
      order_cancel_reason: "Order Cancelation Reason",
      store_order_cancel_reason: "Store Order Cancelation Reason"
    }
  },
  storeOrdersFinance: {
    filename: "Finance_Store_Orders",
    fields: {
      mall_name: "Mall",
      brand_name: "Brand",
      vendor_code: "Vendor Code",
      vertical: "Vertical",
      order_status: "Order Status",
      store_order_status: "Store Order Status",
      order_date: "Order Created Date",
      completed_at: "Order Completion Date",
      store_completed_at: "Store Order Completion Date",
      canceled_at: "Order Cancelation Date",
      order_code: "Order Code",
      store_order_code: "Store Order Code",
      shipping_method_name: "Delivery Type",
      payment_method_type: "Payment Method",
      ipay88_ref_no: "iPay88 Reference Number",
      gateway_trans_id: "Gcash Transaction ID",
      voucher_code: "Voucher Code",
      retail_price: "Total Gross Amount",
      sales_discount_tenant: "Tenant Discount",
      sales_discount_sm: "SMO Discount",
      total_subsidy: "Total Subsidy",
      sales_discount_total: "Total Discount",
      discrepancy: "Discrepancy",
      selling_price: "Total Sales Amount",
      delivery_fee: "Delivery Fee",
      total_gross_transaction: "Total Gross Transaction",
      voucher_discount_tenant: "Tenant Voucher",
      voucher_discount_sm: "SMO Voucher",
      voucher_discount_total: "Total Voucher",
      price_paid: "Price Paid",
      payment_fee: "Payment Fee",
      payment_fee_vat: "VAT on Payment Fee",
      total_payment_fee: "Total Payment Fee",
      payment_fee_witholding_tax: "Withholding Tax on Payment Fee",
      credit_card_witholding_tax:
        "Creditable Withholding Tax on Card Transaction",
      net_settlement: "Net Settlement",
      mdr: "MDR",
      payment_gateway: "Payment Gateway Fee",
      cash_handling_fee: "Cash Handling Fee",
      insurance: "Insurance",
      transaction_income: "Transaction Income / (Loss)",
      is_payout_eligible: "Payout Eligible",
      first_name: "Customer First Name",
      last_name: "Customer Last Name",
      contact_no: "Contact Number",
      email: "Email",
      order_cancel_reason: "Order Cancelation Reason",
      store_order_cancel_reason: "Store Order Cancelation Reason",
      payout_status: "Payout Status",
      in_store_cash_payment: "In Store Cash Payment",
      serviceable: "Serviceable"
    }
  },
  customerActivity: {
    filename: "BI_Customer_Activities",
    fields: {
      email: "Email",
      first_name: "First Name",
      last_name: "Last Name",
      default_mall_name: "Default Mall Name",
      last_login: "Last Login Date",
      last_order_date: "Last Order Date",
      order_status: "Last Order Status",
      completed_at: "Last Completed Order Date"
    }
  },
  customerInfo: {
    filename: "OMI_Customer_Information",
    fields: {
      user_id: "Customer ID",
      email: "Email",
      date_joined: "Date Joined",
      first_name: "First Name",
      last_name: "Last Name",
      gender: "Gender",
      date_of_birth: "Date of Birth",
      age: "Age",
      contact_no: "Contact Number",
      street_address_1: "Default Address"
    }
  },
  orderLines: {
    filename: "BI_Order_Lines",
    fields: {
      mall_name: "Mall",
      brand_name: "Brand",
      sku_level_status: "SKU Level Status",
      order_date: "Order Created Date",
      purchase_type: "First Order or Succeeding Order",
      first_purchase: "Month-Year First Purchase",
      order_code: "Order Code",
      store_order_code: "Store Order Code",
      product_sku: "SKU",
      product_name: "Product",
      variant_name: "Variant",
      quantity: "Quantity",
      retail_price: "Retail Price",
      sales_discount_tenant: "Tenant Discount",
      sales_discount_sm: "SMO Discount",
      sales_discount_total: "Total Discount",
      selling_price: "Selling Price",
      price_paid: "Sales Amount"
    }
  },
  orderLinesFinance: {
    filename: "Finance_Order_Lines",
    fields: {
      mall_name: "Mall",
      brand_name: "Brand",
      order_status: "Order Status",
      store_order_status: "Store Order Status",
      sku_level_status: "SKU Level Status",
      order_date: "Order Created Date",
      completed_at: "Order Completion Date",
      canceled_at: "Order Cancelation Date",
      order_code: "Order Code",
      store_order_code: "Store Order Code",
      shipping_method_name: "Delivery Type",
      payment_method_type: "Payment Method",
      product_sku: "SKU",
      product_name: "Product",
      variant_name: "Variant",
      quantity: "Quantity",
      retail_price: "Old Retail Price",
      price_amount: "Retail Price",
      sales_discount_tenant: "Tenant Discount",
      sales_discount_sm: "SMO Discount",
      total_subsidy: "Total Subsidy",
      sales_discount_total: "Total Discount",
      selling_price: "Selling Price",
      price_paid: "Sales Amount",
      discrepancy: "Discrepancy"
    }
  },
  payouts: {
    filename: "PAYOUT",
    fields: {
      id: "Payout ID",
      mallName: "Mall",
      legalName: "Merchant",
      coverageDate: "Period",
      schedule: "Date Generated",
      fileName: "Filename"
    }
  },
  products: {
    filename: "BI_Product_Performance",
    fields: {
      product_name: "Product Name",
      order_date: "Order Creation Date",
      order_id: "Order Number",
      store_order_code: "Store Order Number",
      signatory_email: "Store Email Address",
      contract_id: "Store Contract ID",
      sku: "Inventory SKU",
      category_name: "Product Category (Level 1, Level 2, Level 3, Level 4)",
      quantity: "Sold Quantity",
      total_net_amount: "Retail Price",
      discount_amount: "Selling Price",
      discount: "Discount (Retail Price - Selling Price)",
      total_gross_transaction: "Price Paid",
      discount_value: "Channel Vouchers (Discount)",
      voucher_code: "Voucher Code",
      currency: "Order Currency",
      status: "Status",
      completed_at: "Order Completion Date",
      price_amount: "Shipping Fee",
      total_gross_amount: "Order Value",
      shipping_method_name: "Delivery Type",
      carrier: "Carrier",
      payment_method_type: "Payment Method",
      mall_name: "Mall Name",
      mall_code: "Mall Code",
      brand_name: "Brand",
      tenant_type: "Store Type",
      length: "Length in cm",
      width: "Width in cm",
      height: "Height in cm",
      weight: "Weight in kg",
      description: "Product Description",
      available_for_purchase: "Available To Purchase Stock",
      total_quantity: "Total Stock"
    }
  },
  voucher: {
    filename: "BI_Voucher",
    fields: {
      voucher_code: "Voucher Code",
      order_code: "Order Code",
      full_name: "Customer Name",
      mall_name: "Mall",
      total_net_amount: "Amount",
      discount_value: "Discount",
      status: "Status",
      shipping_method_name: "Shipping Method",
      payment_method_type: "Payment Method"
    }
  },
  ProductStocks: {
    filename: "OMI_Product_Stocks",
    fields: {
      tenant_id: "Store ID",
      mall_name: "Mall",
      brand_name: "Brand",
      vertical: "Vertical",
      sku: "SKU",
      product_id: "Product ID",
      product_name: "Product Name",
      variant_name: "Variant",
      quantity: "Quantity",
      availability_status: "Availability Status",
      visibility: "Visibility",
      stock_updated_at: "Stock Update Date",
      product_status: "Product Status",
      price_amount: "Retail Price",
      track_inventory: "Track Inventory",
      updated_at: "Product Update Date",
      is_visible: "Published",
      is_available: "Available for Purchase",
      last_published_date: "Last Published Date",
      last_unpublished_date: "Last Unpublished Date"
    }
  },
  Stores: {
    filename: "OMI_Store_Details",
    fields: {
      mall_name: "Mall",
      brand_name: "Brand",
      vertical: "Vertical",
      legal_name: "Legal Name",
      store_type: "Store Type",
      store_status: "Store Status",
      contract_id: "Contract",
      rental_type: "Rental Type"
    }
  },
  StoreDetails: {
    filename: "Finance_Store_Details",
    fields: {
      mall_name: "Mall",
      brand_name: "Brand",
      legal_name: "Legal Name",
      vendor_code: "Vendor Code",
      store_type: "Store Type",
      vertical: "Vertical",
      store_status: "Store Status",
      contract_id: "Contract",
      rental_type: "Rental Type",
      payment_fee_rate: "Payment Fee Rate"
    }
  },
  productCategoriesBi: {
    filename: "BI_Product_Categories",
    fields: {
      category_code: "Category Code",
      category_name: "Category Name",
      level: "Level",
      parent_category: "Parent Category"
    }
  },
  productDetailsBi: {
    filename: "BI_Product_Details",
    fields: {
      id: "Product ID",
      product_name: "Product Name",
      product_status: "Product Status",
      updated_at: "Update Date",
      category_code: "Category Code",
      category_name: "Category Name"
    }
  },
  specialist: {
    filename: "Open_Order",
    fields: {
      order_date: "Order Created Date",
      completed_at: "Order Completion Date",
      store_order_code: "Store Order Code",
      payment_method_type: "Payment Method",
      total_retail_price: "Total Gross Amount",
      sale_discount_tenant: "Tenant Discount",
      sale_discount_sm: "SMO Discount",
      sale_discount_total: "Total Discount",
      total_selling_price: "Total Sales Amount",
      delivery_fee: "Delivery Fee",
      total_gross_transaction: "Total Gross Transaction",
      voucher_discount_tenant: "Tenant Voucher",
      voucher_discount_sm: "SMO Voucher",
      voucher_discount_total: "Total Voucher",
      price_paid: "Price Paid",
      payment_fee: "Payment Fee",
      payment_fee_vat: "VAT on Payment Fee",
      payment_fee_adjustment: "Adjustment on Payment Fee",
      payment_fee_adjustment_vat: "Adjustment VAT on Payment Fee",
      total_payment_fee: "Total Payment Fee",
      payment_fee_witholding_tax: "Withholding Tax on Payment Fee",
      credit_card_witholding_tax:
        "Creditable Withholding Tax on Card Transaction",
      other_adjustment: "Other Adjustment",
      net_settlement: "Net Settlement",
      settlement_date: "Settlement Date"
    }
  },
  grabExpressOmi: {
    filename: "Grab_Express",
    fields: {
      mall_name: "Mall Name",
      ops_firstname: "Ops Admin Account that Trigger Booking",
      order_code: "Order Code",
      order_date: "Order Created Date & Time",
      payment_method_type: "Payment Method (Customer)",
      reference_no: "Grab Reference Number",
      cod_amount: "COD Amount Placed Grab",
      delivery_status: "Grab Status",
      booked_at: "Grab Date & Time Booked",
      shipped_at: "Grab Date & Time Dispatched",
      completed_at: "Grab Date & Time Completed",
      trip_distance: "Ride Distance",
      delivery_cost: "Fare",
      service_type: "Service Type",
      rider_firstname: "Driver Name(First Name)",
      rider_lastname: "Driver Name(Last Name)",
      rider_contact_no: "Drive Contact No.",
      grab_payment_method: "Payment Method"
    }
  },
  activeBatchPayouts: {
    fields: {
      created: "Order Created Date",
      completed_at: "Order Completion Date",
      mall_name: "Mall",
      legal_name: "Company Name",
      brand_name: "Brand",
      vendor_code: "Vendor Code",
      total_retail_price: "Total Retail Price",
      sale_discount_tenant: "Discount - Tenant",
      sale_discount_sm: "Discount - SMO",
      sale_discount_total: "Total - Discount",
      subtotal: "Total Selling Price",
      shipping_cost: "Delivery Fee",
      total_gross_transaction: "Total Gross Transaction",
      voucher_discount_tenant: "Voucher - Tenant",
      voucher_discount_sm: "Voucher - SMO",
      discount_amount: "Total - Voucher",
      price_paid: "Price Paid",
      payment_fee: "Payment Fee",
      payment_fee_vat: "VAT on Payment Fee",
      payment_fee_adjustment: "Adjustment on Payment Fee",
      payment_fee_adjustment_vat: "Adjustment VAT on Payment Fee",
      total_payment_fee: "Total Payment Fee",
      payment_fee_witholding_tax: "Withholding Tax on Payment Fee",
      delivery_fee_adjustment: "Adjustment on Delivery Fee",
      credit_card_witholding_tax:
        "Creditable Withholding Tax on Card Transaction",
      other_adjustment: "Other Adjustment",
      net_settlement: "Net Settlement",
      settlement_date: "Settlement Date"
    }
  },
  batchHistoryListPayouts: {
    fields: {
      mall_name: "Mall",
      legal_name: "Company Name",
      brand_name: "Brand",
      vendor_code: "Vendor Code",
      total_retail_price: "Total Retail Price",
      sale_discount_tenant: "Discount - Tenant",
      sale_discount_sm: "Discount - SMO",
      sale_discount_total: "Total - Discount",
      subtotal: "Total Selling Price",
      shipping_cost: "Delivery Fee",
      total_gross_transaction: "Total Gross Transaction",
      voucher_discount_tenant: "Voucher - Tenant",
      voucher_discount_sm: "Voucher - SMO",
      discount_amount: "Total Voucher",
      price_paid: "Price Paid",
      payment_fee: "Payment Fee",
      payment_fee_vat: "VAT on Payment Fee",
      payment_fee_adjustment: "Adjustment on Payment Fee",
      payment_fee_adjustment_vat: "Adjustment VAT on Payment Fee",
      total_payment_fee: "Total Payment Fee",
      payment_fee_witholding_tax: "Withholding Tax on Payment Fee",
      delivery_fee_adjustment: "Adjustment on Delivery Fee",
      credit_card_witholding_tax:
        "Creditable Withholding Tax on Card Transaction",
      other_adjustment: "Other Adjustment",
      net_settlement: "Net Settlement",
      settlement_date: "Settlement Date",
      rejection_reason: "Rejection Reason"
    }
  },
  fnManagerFormat: {
    fields: {
      mall_name: "Mall",
      legal_name: "Company Name",
      brand_name: "Brand",
      vendor_code: "Vendor Code",
      total_retail_price: "Total Retail Price",
      sale_discount_tenant: "Discount - Tenant",
      sale_discount_sm: "Discount - SMO",
      sale_discount_total: "Total - Discount",
      subtotal: "Total Selling Price",
      shipping_cost: "Delivery Fee",
      total_gross_transaction: "Total Gross Transaction",
      voucher_discount_tenant: "Voucher - Tenant",
      voucher_discount_sm: "Voucher - SMO",
      discount_amount: "Total Voucher",
      price_paid: "Price Paid",
      payment_fee: "Payment Fee",
      payment_fee_vat: "VAT on Payment Fee",
      payment_fee_adjustment: "Adjustment on Payment Fee",
      payment_fee_adjustment_vat: "Adjustment VAT on Payment Fee",
      total_payment_fee: "Total Payment Fee",
      payment_fee_witholding_tax: "Withholding Tax on Payment Fee",
      delivery_fee_adjustment: "Adjustment on Delivery Fee",
      credit_card_witholding_tax:
        "Creditable Withholding Tax on Card Transaction",
      other_adjustment: "Other Adjustment",
      net_settlement: "Net Settlement",
      settlement_date: "Settlement Date"
    }
  },
  payablesListPayouts: {
    fields: {
      mall_name: "Mall",
      company_name: "Company Name",
      brand_name: "Brand",
      vendor_code: "Vendor Code",
      net_settlement: "Net Settlement",
      coverage_start_date: "Period Covered",
      settlement_date: "Settlement Date"
    }
  },
  merchantSettlementOrderDetails: {
    filename: "Merchant_Settlement",
    field: {
      mall_name: "Mall",
      brand_name: "Brand",
      store_order_code: "Store Order Code",
      delivery_type: "Delivery Type",
      payment_method: "Payment Method",
      total_gross_amount: "Total Gross Amount",
      tenant_discount: "Tenant Discount",
      net_sales: "Net Sales",
      tenant_voucher: "Tenant Voucher",
      payment_fee: "Payment Fee",
      total_deductions: "Total Deductions",
      adjustment_on_payment_fee: "Adjustment on Payment Fee",
      adjustment_on_delivery_fee: "Adjustment on Delivery Fee",
      penalties: "Penalties",
      other_adjustments: "Other Adjustments",
      other_adjustment_remarks: "Other Adjustment Remarks",
      total_adjustments: "Total Adjustments",
      creditable_withholding_tax_on_prepaid:
        "Creditable Withholding Tax on Prepaid Transactions",
      withholding_tax_on_payment_fee: "Withholding Tax on Payment Fee",
      in_store_cash_payments: "In-Store Cash Payments",
      net_amount_for_settlement: "Net Amount for Settlement"
    }
  },
  mallOrdersBi: {
    filename: " BI_Total_Completed_Orders_Date.",
    fields: {
      mall_name: "Mall",
      order_count: "No. of Orders"
    }
  },
  transportReport: {
    filename: "Transport_Report",
    fields: {
      mall_name: "Mall",
      order_code: "Order Code",
      brand_name: "Brand",
      store_order_status: "Status",
      vertical: "Classification",
      shipping_method_name: "Delivery Type",
      voucher_code: "Voucher Code",
      payment_method_type: "Payment Method Type",
      price_paid: "Price Paid",
      customer_name: "Customer Name",
      contact_no: "Contact No.",
      email: "Email",
      street_address_1: "Address",
      delivery_distance_in_km: "Distance from Mall (km)",
      created: "Order Created Date",
      order_collect_date: "Order Collected Date",
      shipping_schedule: "Target Delivery Date",
      booked_at: "Order Booked At Date",
      shipped_at: "Order Shipped Date",
      shipping_company: "Order Shipped User",
      rider_arrive_time: "Rider Arrival Time",
      completed_at: "Order Completion Date",
      completed_by: "Order Completion User",
      canceled_at: "Order Cancellation Date",
      cancelled_by: "Order Cancellation User",
      cancel_reason: "Order Cancellation Reason",
      courier: "Rider Company Name",
      rider_name: "Rider Full Name",
      rider_contact_no: "Rider Number",
      latitude: "Latitude",
      longitude: "Longitude",
      trip_distance: "Trip Distance (km)",
      actual_lat: "Actual Latitude",
      actual_long: "Actual Longitude",
      total_time: "Total Time",
      dwell_time: "Dwell Time",
      on_time: "On Time",
      late_dispatch_reason: "Ops Admin Reason for Late Delivery",
      late_delivery_reason: "Rider Reason for Late Delivery",
      proof_of_pickup: "Proof of Pickup",
      proof_of_delivery: "Proof of Delivery",
      remarks: "Remarks"
    }
  }
};
